import { CoordinatesType } from './popover.types';

type VerticalPositionType = 'onTop' | 'onBottom';
type HorizontalPositionType = 'onRight' | 'onLeft';

export function getPosition({
  window,
  cursorPosition,
}: {
  window: Window;
  cursorPosition: CoordinatesType;
}): {
  popoverYPosition: VerticalPositionType;
  popoverXPosition: HorizontalPositionType;
} {
  const windowHeigth = window.innerHeight;
  const windowWidth = window.innerWidth;
  const popoverYPosition =
    cursorPosition.y > windowHeigth / 2 ? 'onTop' : 'onBottom';
  const popoverXPosition =
    cursorPosition.x > windowWidth / 2 ? 'onRight' : 'onLeft';
  return { popoverYPosition, popoverXPosition };
}

export function getStyles({
  window,
  cursorPosition,
  popoverYPosition,
  popoverXPosition,
}: {
  window: Window;
  cursorPosition: CoordinatesType;
  popoverYPosition: VerticalPositionType;
  popoverXPosition: HorizontalPositionType;
}) {
  const pageHeight = window.document.body.offsetHeight;
  const verticalGap = 20;
  const scrollbarWidth = 30;
  const marginPopover = 20;
  const maxWidth = 400;
  const windowWidth = window.innerWidth;
  const scrollTop = window.pageYOffset;

  const popoverStyle: {
    top: string | null;
    bottom: string | null;
    left: string | null;
    right: string | null;
  } = {
    top: null,
    bottom: null,
    left: null,
    right: null,
  };

  switch (popoverYPosition) {
    case 'onBottom': {
      const topOffset = cursorPosition.y + scrollTop + verticalGap;
      popoverStyle.bottom = null;
      popoverStyle.top = `${topOffset}px`;
      break;
    }
    default: {
      const bottomOffset =
        pageHeight - (cursorPosition.y + scrollTop) + verticalGap;
      popoverStyle.top = 'auto';
      popoverStyle.bottom = `${bottomOffset}px`;
      break;
    }
  }

  switch (popoverXPosition) {
    case 'onRight': {
      const availableSpace = cursorPosition.x - marginPopover;
      const unusedSpace =
        windowWidth - cursorPosition.x - marginPopover - scrollbarWidth;
      const missingSpace = Math.max(0, maxWidth - availableSpace);
      const offset = Math.min(missingSpace, unusedSpace);

      popoverStyle.left = 'auto';
      popoverStyle.right = `${
        windowWidth - cursorPosition.x - scrollbarWidth - offset
      }px`;

      break;
    }
    default: {
      const availableSpace = windowWidth - cursorPosition.x - scrollbarWidth;
      const unusedSpace = windowWidth - cursorPosition.x;
      const missingSpace = Math.max(0, maxWidth - availableSpace);
      const offset = Math.min(missingSpace, unusedSpace);

      popoverStyle.right = 'auto';
      popoverStyle.left = `${cursorPosition.x - offset - scrollbarWidth}px`;
      break;
    }
  }
  return { popoverStyle };
}
